// extracted by mini-css-extract-plugin
export default {"item":"Item-module__item--576f","inactive":"Item-module__inactive--688c","talent":"Item-module__talent--16a7","status":"Item-module__status--0b9a","more":"Item-module__more--1632"};